import React from 'react';
import {
    PieChart as RechartsPieChart,
    Pie,
    Cell,
    Tooltip,
    Legend,
    ResponsiveContainer
} from 'recharts';
import './PieChart.scss';

const PieChart = ({
    data = [],
    dataKey = 'value',
    nameKey = 'name',
    height = 300,
    colors = ['#42a5f5', '#ec407a', '#1976d2', '#f44336'],
    showTooltip = true,
    showLegend = true,
    formatTooltip,
    paddingAngle = 0,
    loading = false
}) => {
    if (loading) {
        return (
            <div className="chart-loading" style={{ height: `${height}px` }}>
                <div className="loading-skeleton"></div>
            </div>
        );
    }

    if (!data || data.length === 0) {
        return (
            <div className="chart-empty" style={{ height: `${height}px` }}>
                <p>No data available</p>
            </div>
        );
    }

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const data = payload[0];
            return (
                <div className="custom-tooltip">
                    <p className="tooltip-label">{data.name}</p>
                    <p style={{ color: data.color }}>
                        {formatTooltip ? formatTooltip(data.value) : data.value}
                    </p>
                </div>
            );
        }
        return null;
    };

    return (
        <div className="pie-chart-container">
            <ResponsiveContainer width="100%" height={height}>
                <RechartsPieChart>
                    <Pie
                        data={data}
                        cx="50%"
                        cy="50%"
                        labelLine={false}
                        label={showLegend ? false : ({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                        outerRadius={80}
                        fill="#8884d8"
                        dataKey={dataKey}
                        paddingAngle={paddingAngle}
                    >
                        {data.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                        ))}
                    </Pie>
                    {showTooltip && <Tooltip content={<CustomTooltip />} />}
                    {showLegend && <Legend />}
                </RechartsPieChart>
            </ResponsiveContainer>
        </div>
    );
};

export default PieChart;

